import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=6c5d19cf&scoped=true&"
import script from "./MessageDetail.vue?vue&type=script&lang=ts&"
export * from "./MessageDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=6c5d19cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d19cf",
  null
  
)

export default component.exports